var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownload48Line = function SvgIconDownload48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3 25v8.4a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9V25H9.3v8.4c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V25h-3.4Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.78c.79 0 1.55-.33 2.1-.9l6.05-6.35-2.46-2.35-3.99 4.19V9.34h-3.4v14.03l-3.99-4.19-2.46 2.35 6.05 6.35c.54.57 1.31.9 2.1.9Z",
    fill: "current"
  })));
};
export default SvgIconDownload48Line;